import * as angular from "angular";
import moment from "moment";

import { BoxAccidentBodyControllerBase, IDiscountListItem } from "../boxAccidentBodyControllerBase";
import { FamilyAccidentInsuredPerson } from "./familyAccident.factory";

export class FamilyAccidentController extends BoxAccidentBodyControllerBase {
    public $onInit() {
        super.$onInit();

        this.registrationDateConfig = {
            endDate: moment().format("YYYY-MM-DD"),
            startDate: moment().subtract(100, "years").format("YYYY-MM-DD"),
        };

        if (!this.Contract.ContractStatusId) {
            this.Contract.SigningDate = moment().format("YYYY-MM-DD");
            this.Contract.ContractFrom = this.getContractFromMinDate();
            this.Contract.UnderwriterCoefficient = this.Repository.UnderwriterCoefficientRestriction.Collection[0].MinValue;
            this.insuranceTermChanged();
        }

        this.contractMinDate = this.getContractFromMinDate();
        this.contractMaxDate = moment(this.Contract.SigningDate, "YYYY-MM-DD").add(6, "months").format("YYYY-MM-DD");

        this.discountCollection = this.getDiscountCollection();

        this.maxCountInsuredPersons = this.Repository.InsuredPersonCountRestriction.Collection[0].MaxValue;
        this.defaultNumberOfInsuredPersons = this.Repository.InsuredPersonCountRestriction.Collection[0].MaxValue;

        if (!angular.isArray(this.Contract.InsuredPersons)) {
            this.Contract.InsuedPersons = [];
        }

        if (angular.equals(this.Contract.InsuredPersons.length, 0)) {
            for (let i = 0; i < this.defaultNumberOfInsuredPersons; i++) {
                this.Contract.InsuredPersons.push(new FamilyAccidentInsuredPerson());
            }
        }
    }

    public addPerson() {
        this.Contract.InsuredPersons.push(new FamilyAccidentInsuredPerson());
        this.pageSharedData.Form.modified = true;
    }

    public insuranceProgramChanged() {
        this.blockUI.start("Обновляются справочные данные");
        const [$timeout] = this.di(["$timeout"]);
        return $timeout(() => {
            this.Repository.update("InsuranceProgram", this.Contract).then(() => {
                this.blockUI.stop();
                this.maxCountInsuredPersons = this.Repository.InsuredPersonCountRestriction.Collection[0].MaxValue;
                this.defaultNumberOfInsuredPersons = this.Repository.InsuredPersonCountRestriction.Collection[0].MaxValue;
                if (this.Contract.InsuredPersons.length > this.maxCountInsuredPersons) {
                    this.Contract.InsuredPersons.length = this.maxCountInsuredPersons;
                } else {
                    const toValue = this.maxCountInsuredPersons - this.Contract.InsuredPersons.length;
                    for (let i = 0; i < toValue; i++) {
                        this.Contract.InsuredPersons.push(new FamilyAccidentInsuredPerson());
                    }
                }
            });
        });
    }

    public getDiscountCollection(): IDiscountListItem[] {
        const collection = [];
        let labelDiscount = "";
        const fromValue = this.Repository.DiscountRestriction.Value[0].Value;
        const toValue = this.Repository.DiscountRestriction.Value[1].Value;

        for (let i = fromValue; i <= toValue; i++) {
            if (i > 0) {
                labelDiscount = `${i} %`;
            } else {
                labelDiscount = "Без скидки";
            }

            collection.push({ Id: i, Value: labelDiscount });
        }
        return collection;
    }

    public insuredPersonIsInsuredChanged() {
        if (this.isInsuredPersonIsInsured()) {
            if (this.insuredWatcher) {
                this.insuredWatcher();
            }

            this.removeInsuredPerson(0);
            if (this.Contract.InsuredPersons.length < this.defaultNumberOfInsuredPersons) {
                const toValue = this.defaultNumberOfInsuredPersons - this.Contract.InsuredPersons.length;
                for (let i = 0; i < toValue; i++) {
                    this.addPerson();
                }
            }
        } else {
            if ((this.Contract.InsuredPersons.length > 0) && (this.Contract.InsuredPersons[0].Guid !== this.Contract.InsuredGuid)) {
                const insuredPerson = new FamilyAccidentInsuredPerson();
                insuredPerson.Guid = this.Contract.InsuredGuid;
                if ((this.Contract.InsuredPersons.length === this.defaultNumberOfInsuredPersons) && this.isEmptyPerson(this.Contract.InsuredPersons[0])) {
                    this.Contract.InsuredPersons = [insuredPerson];
                    for (let i = 0; i < this.defaultNumberOfInsuredPersons - 1; i++) {
                        this.Contract.InsuredPersons.push(new FamilyAccidentInsuredPerson());
                    }
                } else {
                    Object.keys(this.Contract.InsuredPersons[0]).forEach(prop => {
                        if (!["Guid", "SpecialNote"].includes(prop)) {
                            const targetProp = prop.replace("Person", "");

                            if (this.Contract.hasOwnProperty(targetProp)) {
                                this.Contract.InsuredPersons[0][prop] = this.Contract[targetProp];
                            }
                        }
                    });
                    this.Contract.InsuredPersons[0].Guid = this.Contract.InsuredGuid;
                }
            }

            this.watchForInsuredPerson();
        }
    }

    public insuranceTermChanged() {
        this.Contract.ContractTo = moment(this.Contract.ContractFrom, "YYYY-MM-DD")
            .add(12, "months")
            .subtract(1, "days")
            .format("YYYY-MM-DD");
    }

    public getContractFromMinDate() {
        return moment(this.Contract.SigningDate, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD");
    }

    public isDisabledAddInsuredPerson() {
        return (this.Contract.InsuredPersons.length >= this.maxCountInsuredPersons) && (!this.insuredPersonIsInsured) && (!this.isEmptyPerson(this.Contract.InsuredPersons[0]));
    }
}
